import React from 'react';

import { UserAgent } from '@quentin-sommer/react-useragent';

const AppleLogo = () => (
  <svg width="21" height="21" viewBox="0 0 24 24" fill="#fff" aria-hidden>
    <path d="M16.365 1.43c0 1.14-.417 2.2-1.11 2.98-.83.94-2.19 1.67-3.29 1.58-.14-1.13.42-2.31 1.08-3.06.74-.84 2.03-1.47 3.32-1.5zM20.5 17.02c-.55 1.27-.82 1.83-1.53 2.95-.99 1.57-2.39 3.52-4.12 3.53-1.54.01-1.94-.99-4.03-.98-2.09.01-2.53.99-4.07.97-1.73-.02-3.05-1.79-4.04-3.36-2.76-4.41-3.05-9.94-.94-13.01 1.03-1.53 2.66-2.5 4.42-2.53 1.7-.02 2.79 1.02 4.03 1.02 1.23 0 1.98-1.02 4.03-1.02 1.79.02 3.32 1.02 4.37 2.55-3.84 2.11-3.22 7.61.44 8.31z" />
  </svg>
);

const PlayLogo = () => (
  <svg width="19" height="21" viewBox="0 0 512 512" aria-hidden>
    <path fill="#00d2ff" d="M47 32C36 38 30 49 30 65v382c0 16 6 27 17 33l223-224z" />
    <path fill="#00f076" d="M47 32c4-2 9-2 15 1l283 163-63 63z" />
    <path fill="#ffce00" d="M345 196l72 41c22 13 22 35 0 48l-72 41-64-64z" />
    <path fill="#ff3a44" d="M47 480c6 3 11 3 15 1l283-163-63-63z" />
  </svg>
);

const StoreButton = ({
  onClick,
  ariaLabel,
  icon,
  topLine,
  bottomLine,
}: {
  onClick: () => void;
  ariaLabel: string;
  icon: React.ReactNode;
  topLine: string;
  bottomLine: string;
}) => (
  <button
    type="button"
    aria-label={ariaLabel}
    onClick={onClick}
    className="flex flex-1 items-center gap-2 rounded-[10px] bg-ro-ink px-4 py-2 text-white"
  >
    {icon}
    <span className="flex flex-col text-left leading-tight">
      <span className="text-[9px] font-normal opacity-[0.85]">{topLine}</span>
      <span className="text-sm font-semibold">{bottomLine}</span>
    </span>
  </button>
);

const Footer = ({ variant }: { variant: 'panel' | 'sheet' }) => {
  const isPanel = variant === 'panel';
  return (
    <div
      className={
        isPanel
          ? 'shrink-0 border-t border-ro-border bg-white px-7 pb-4 pt-4'
          : 'mt-5 border-t border-ro-border pt-4'
      }
    >
      <div
        className={`mb-2.5 text-[12.5px] font-semibold text-ro-stone ${
          isPanel ? '' : 'text-center'
        }`}
      >
        Get the RushOwl app for live alerts
        {process.env.NEXT_PUBLIC_APP_ENV !== 'production' && (
          <span className="ml-2 rounded bg-ro-now-bg px-1.5 py-0.5 text-[10px] font-extrabold text-ro-yellow-dark">
            TEST
          </span>
        )}
      </div>
      <div className={`flex gap-2.5 ${isPanel ? '' : 'justify-center'}`}>
        {/* @ts-ignore */}
        <UserAgent ios mac chrome edge firefox safari linux>
          <StoreButton
            ariaLabel="Download on the App Store"
            icon={<AppleLogo />}
            topLine="Download on the"
            bottomLine="App Store"
            onClick={() => {
              (window as any).location = 'https://apps.apple.com/sg/app/rushtrail/id1476365823?mt=8';
            }}
          />
        </UserAgent>
        {/* @ts-ignore */}
        <UserAgent android mac chrome edge firefox safari linux>
          <StoreButton
            ariaLabel="Get it on Google Play"
            icon={<PlayLogo />}
            topLine="GET IT ON"
            bottomLine="Google Play"
            onClick={() => {
              (window as any).open(
                'https://play.google.com/store/apps/details?id=com.rush.rushtrail&hl=sg',
                '_blank'
              );
            }}
          />
        </UserAgent>
      </div>
    </div>
  );
};

export default Footer;
